module.exports = __webpack_public_path__ + "img/photo-studio-razor-7.5.be8db96f.png";